import { Box, useTheme } from '@mui/material'
import { Lottie } from 'lottie-react'

import useIsMobile from '../../utils/hooks/useIsMobile'
import useWindowDimensions from '../../utils/hooks/useWindowDimensions'

import useStyles from './index.styles'

const SensorActivationAnimation = ({ animation, loop, sx }: { animation: object; loop: boolean; sx?: object }) => {
  const classes = useStyles
  const theme = useTheme()

  const { height: windowHeight, width: windowWidth } = useWindowDimensions()
  const isMobile = useIsMobile()

  return (
    <>
      <Box sx={{ ...classes.animation(theme), ...sx }}>
        <Lottie
          src={animation}
          autoplay={true}
          loop={loop}
          rendererSettings={{
            preserveAspectRatio: 'xMidYMin meet',
            viewBoxSize: `0 0 ${isMobile ? windowWidth : 375} ${isMobile ? windowHeight - 148 : 812}`,
          }}
        />
      </Box>
    </>
  )
}

export default SensorActivationAnimation
